import React, { useState, useEffect } from 'react'
import { connect, useSelector } from 'react-redux'
import {
  Nav,
  Navbar,
  NavbarToggler,
  Collapse,
  Row,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap'
import { Link, useHistory } from 'react-router-dom'
import { VscChevronDown } from 'react-icons/vsc'
import { VscSettingsGear } from 'react-icons/vsc';
import Avatar from '@mui/material/Avatar'
import { logout, loadUser } from '../actions/authActions'
import { userOffline } from '../actions/firebaseAction'
import { getLabelsName } from "../actions/lableAction"
import { useDispatch } from "react-redux";
import { useLocation } from 'react-router-dom';

const mapStateToProps = (state) => ({
  language: state.language,
  auth: state.auth,
  label: state.language,
  subscription: state.subscription
})

const LoggedHeader = (props) => {
  const { frontLabelsName } = props.label
  const { getLabelsName } = props
  const dispatch = useDispatch();
  const location = useLocation();
  const { isInRegistration } = useSelector((state) => state.registration)
  const [collapsed, setCollapsed] = useState(false)
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [dropdownOpen1, setDropdownOpen1] = useState(false)
  const [dropdownValue, setDropdownValue] = useState('')
  const language = useSelector((state) => state.language)
  const { languages, loading } = language

  const userName = props.auth.user
  const subscriptions = props.subscription;

  console.log("subscription_details: ", subscriptions)

  const [finLan, setFinLan] = useState(
    language?.languages.find(
      (item) => item.language_code === localStorage.getItem('i18nextFront')
    )?.image
  )

  useEffect(() => {
    if (localStorage.getItem('i18nextFront')) {
      setDropdownValue(localStorage.getItem('i18nextFront'))
    } else {
      setFinLan(languages?.filter((data) => data?.default === 1)[0]?.image)
      setDropdownValue(languages?.filter((data) => data?.default === 1)[0]?.language_code)
    }
  }, [])

  const handleLanguageChange = async (e, lng) => {
    localStorage.setItem('i18nextFront', lng?.language_code)
    const prevLang = localStorage.getItem('i18nextFront')
    localStorage.setItem('prevLangFront', prevLang)

    setFinLan(lng?.image)
    getLabelsName()
  }

  const currentLanguageCode = languages?.filter(
    (data) => data?.default === 1
  )[0]?.image

  return (
    <header className="nav-shadow">
      <Row className="header-row">
        <Navbar expand="lg" container={false} className="ps-3 pe-3">
          <Link to="/">
            <img src={'assets/icons/logo.svg'} alt="" />
          </Link>
          <NavbarToggler onClick={() => setCollapsed((prev) => !prev)} />
          <Collapse navbar isOpen={collapsed} className="navbar-collapse">
            <Nav className="d-flex  ms-auto align-items-center paddint-top-class" navbar>
              <UncontrolledDropdown
                nav
                direction="down"
                className="nav-link logged-user-pad"
                inNavbar
                onMouseOver={() => setDropdownOpen(true)}
                onMouseLeave={() => setDropdownOpen(false)}
                isOpen={dropdownOpen}
              >
                <div className='capsule-style d-flex align-items-center'>
                  <Link to="/my-profile">
                    <img
                      src={userName?.profile_pic ? userName?.profile_pic : "assets/user.png"}
                      className={userName?.profile_pic ? "logged-user-icons ms-0 ms-lg-1" : "logged-user-iconsaa "}
                      alt="profile"

                    />
                  </Link>
                  <DropdownToggle nav className="dropdown-hover-border d-flex align-items-center ps-1 py-1">
                    <span className="me-1 logged-user-text">
                      {userName?.full_name}
                    </span>
                    <span>
                      <VscSettingsGear className="logged-dropdown-icon remove-stroke" />
                    </span>
                  </DropdownToggle>
                </div>
                <DropdownMenu
                  className={`dropdown-menu-style ${isInRegistration ? "" : "min-width-new-classz"}`}
                  style={{ zIndex: '10000' }}
                >
                  {!isInRegistration &&
                    <>
                      <DropdownItem className="d-flex justify-content-between align-items-center  dropdown-bottom-border">
                        <div className={location.pathname == "/subscription-history" ? "hover-effect-class-active" : "hover-effect-class"}>
                          <Link to="/subscription-history" className="header-dropdown">
                            <label className="logged-user-text">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == 'lbl_subscription'
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == 'lbl_subscription'
                                  )[0]['value'] || 'lbl_subscription'
                                  : 'lbl_subscription'
                                : 'lbl_subscription'}
                            </label>
                          </Link>
                        </div>
                      </DropdownItem>
                      <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                        <div className={location.pathname == "/tenant-profile" ? "hover-effect-class-active" : "hover-effect-class"}>
                          <Link to="/tenant-profile" className="header-dropdown">
                            <label className="logged-user-text">{frontLabelsName
                              ? frontLabelsName.filter(
                                (e) => e.key == 'lbl_tenant_profile'
                              ).length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == 'lbl_tenant_profile'
                                )[0]['value'] || 'lbl_tenant_profile'
                                : 'lbl_tenant_profile'
                              : 'lbl_tenant_profile'}</label>
                          </Link>
                        </div>
                      </DropdownItem>
                      <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                        <div className={location.pathname == "/property-watch" ? "hover-effect-class-active" : "hover-effect-class"}>
                          <Link to="/property-watch" className="header-dropdown">
                            <label className="logged-user-text">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == 'lbl_property_watch'
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == 'lbl_property_watch'
                                  )[0]['value'] || 'lbl_property_watch'
                                  : 'lbl_property_watch'
                                : 'lbl_property_watch'}
                            </label>
                          </Link>
                        </div>
                      </DropdownItem>
                      <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                        <div className={location.pathname == "/update-renter-info" ? "hover-effect-class-active" : "hover-effect-class"}>
                          <Link to="/update-renter-info" className="header-dropdown">
                            <label className="logged-user-text">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == 'lbl_renters_list'
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == 'lbl_renters_list'
                                  )[0]['value'] || 'lbl_renters_list'
                                  : 'lbl_renters_list'
                                : 'lbl_renters_list'}
                            </label>
                          </Link>
                        </div>
                      </DropdownItem>

                      <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                        <div className={location.pathname == "/chat-view" ? "hover-effect-class-active" : "hover-effect-class"}>
                          <Link to="/chat-view" className="header-dropdown">
                            <label className="logged-user-text">
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == 'lbl_inbox')
                                  .length > 0
                                  ? frontLabelsName.filter((e) => e.key == 'lbl_inbox')[0][
                                  'value'
                                  ] || 'lbl_inbox'
                                  : 'lbl_inbox'
                                : 'lbl_inbox'}
                            </label>
                          </Link>
                        </div>
                      </DropdownItem>


                      <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border cursor-default-class">
                        <div className='non-link-class '>
                          <Link to="#" className="header-dropdown cursor-default-class">
                            <label className="logged-user-text cursor-default-class">{frontLabelsName
                              ? frontLabelsName.filter((e) => e.key == "lbl_properties")
                                .length > 0
                                ? frontLabelsName.filter(
                                  (e) => e.key == "lbl_properties"
                                )[0]["value"] || "lbl_properties"
                                : "lbl_properties"
                              : "lbl_properties"} </label>
                          </Link>
                        </div>
                      </DropdownItem>

                      <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                        <div className={location.pathname == "/favourite-properties" ? "hover-effect-class-active" : "hover-effect-class"}>
                          <Link
                            to="/favourite-properties"
                            className="header-dropdown"
                          >
                            <label className="logged-user-text ps-4">
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == 'lbl_favourites')
                                  .length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == 'lbl_favourites'
                                  )[0]['value'] || 'lbl_favourites'
                                  : 'lbl_favourites'
                                : 'lbl_favourites'}
                            </label>
                          </Link>
                        </div>
                      </DropdownItem>
                      <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                        <div className={location.pathname == "/applied-properties" ? "hover-effect-class-active" : "hover-effect-class"}>
                          <Link to="/applied-properties" className="header-dropdown">
                            <label className="logged-user-text ps-4">
                              {frontLabelsName
                                ? frontLabelsName.filter((e) => e.key == 'lbl_applied_for')
                                  .length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == 'lbl_applied_for'
                                  )[0]['value'] || 'lbl_applied_for'
                                  : 'lbl_applied_for'
                                : 'lbl_applied_for'}

                            </label>
                          </Link>
                        </div>
                      </DropdownItem>
                      <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                        <div className={location.pathname == "/hidden-properties" ? "hover-effect-class-active" : "hover-effect-class"}>
                          <Link to="/hidden-properties" className="header-dropdown">
                            <label className="logged-user-text ps-4">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == 'lbl_hidden_properties'
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == 'lbl_hidden_properties'
                                  )[0]['value'] || 'lbl_hidden_properties'
                                  : 'lbl_hidden_properties'
                                : 'lbl_hidden_properties'}
                            </label>
                          </Link>
                        </div>
                      </DropdownItem>
                      <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                        <div className={location.pathname == "/reported-properties" ? "hover-effect-class-active" : "hover-effect-class"}>
                          <Link to="/reported-properties" className="header-dropdown">
                            <label className="logged-user-text ps-4">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == 'lbl_reported_properties'
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == 'lbl_reported_properties'
                                  )[0]['value'] || 'lbl_reported_properties'
                                  : 'lbl_reported_properties'
                                : 'lbl_reported_properties'}
                            </label>
                          </Link>
                        </div>
                      </DropdownItem>

                      <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                        <div className={location.pathname == "/change-password" ? "hover-effect-class-active" : "hover-effect-class"}>
                          <Link to="/change-password" className="header-dropdown">
                            <label className="logged-user-text">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == 'lbl_change_password'
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == 'lbl_change_password'
                                  )[0]['value'] || 'lbl_change_password'
                                  : 'lbl_change_password'
                                : 'lbl_change_password'}
                            </label>
                          </Link>
                        </div>
                      </DropdownItem>
                      <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border">
                        <div className={location.pathname == "/notification" ? "hover-effect-class-active" : "hover-effect-class"}>
                          <Link to="/notification" className="header-dropdown">
                            <label className="logged-user-text">
                              {frontLabelsName
                                ? frontLabelsName.filter(
                                  (e) => e.key == 'lbl_notifications'
                                ).length > 0
                                  ? frontLabelsName.filter(
                                    (e) => e.key == 'lbl_notifications'
                                  )[0]['value'] || 'lbl_notifications'
                                  : 'lbl_notifications'
                                : 'lbl_notifications'}
                            </label>
                          </Link>
                        </div>
                      </DropdownItem></>}
                  <DropdownItem className="d-flex justify-content-between align-items-center dropdown-bottom-border12">
                    <div className={"hover-effect-class"}>
                      <Link
                        to="/login"
                        className="header-dropdown"
                        onClick={() => {
                          dispatch({
                            type: "SET_STEP",
                            payload: { step: 0, status: false }
                          });
                          localStorage.removeItem("isSubscribing")
                          props.userOffline()
                          props.logout()
                        }}
                      >
                        <label className="logged-user-text">
                          {frontLabelsName
                            ? frontLabelsName.filter((e) => e.key == 'lbl_logout')
                              .length > 0
                              ? frontLabelsName.filter(
                                (e) => e.key == 'lbl_logout'
                              )[0]['value'] || 'lbl_logout'
                              : 'lbl_logout'
                            : 'lbl_logout'}
                        </label>
                      </Link>
                    </div>
                  </DropdownItem>
                </DropdownMenu>
              </UncontrolledDropdown>
              <UncontrolledDropdown
                nav
                direction="down"
                className="logged-user-pad1 margin-right-class"
                onMouseOver={() => setDropdownOpen1(true)}
                onMouseLeave={() => setDropdownOpen1(false)}
                isOpen={dropdownOpen1}
              // toggle={(prev)=>setDropdownOpen1(!prev)} 
              >
                <div className='capsule-style'>
                  <DropdownToggle nav className="nav-style d-flex align-items-center dropdown-hover-border py-1">
                    <>
                      <img
                        src={finLan || currentLanguageCode}
                        alt="logged1"
                        className="logged-img-style ps-1"
                      />

                      <span className="drop-down-arrow ps-1">
                        <VscChevronDown className="logged-dropdown-icon" />
                      </span>
                    </>
                  </DropdownToggle>
                </div>

                <DropdownMenu className="dropdown-menu-style">
                  {!loading &&
                    languages.map((data, index) => {
                      return (
                        <DropdownItem
                          onChange={(e) => setDropdownValue(data.language_code)}
                          onClick={(e) => { handleLanguageChange(e, data); setDropdownValue(data.language_code) }}
                          value={dropdownValue}
                          key={index}
                          className={`  d-flex justify-content-between align-items-center dropdown-bottom-border`}
                        >
                          <div className={data.language_code ===
                            localStorage.getItem('i18nextFront') ? "hover-effect-class-active" : "hover-effect-class"}>
                            <span className="d-flex align-items-center logo-position">
                              <Avatar
                                alt={data.language_name}
                                src={data.image}
                                className="lang-avtar-style"
                              />
                              <label className=" header-dropdown">
                                {data.language_name}
                              </label>
                            </span>
                          </div>
                        </DropdownItem>
                      )
                    })}
                </DropdownMenu>
              </UncontrolledDropdown>
            </Nav>
          </Collapse>
        </Navbar>
      </Row>
    </header>
  )
}

export default connect(mapStateToProps, {
  loadUser,
  logout,
  userOffline, getLabelsName
})(LoggedHeader)
